class DataCollectionViewsInterfaces {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/data-collection-views`;

  }

  async getDataCollectionViewForEditor(collectionViewId, queryOptions) {

    const path = `${this.basePath}/:collectionViewId/records/public`;

    return this.apiClient.get(path, { collectionViewId }, queryOptions, {});

  }

}

export default DataCollectionViewsInterfaces;